declare namespace $ {

	type $mol_button_minor__hint_shm_hitalama_guide_repository_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_guide_repository_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_repository['close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_guide_repository_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_string__enabled_shm_hitalama_guide_repository_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_repository['editable'] >
		,
		ReturnType< $mol_string['enabled'] >
	>
	type $mol_string__value_shm_hitalama_guide_repository_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_repository['repository'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_guide_repository_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_guide_repository_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_repository['Repository_input'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_text__text_shm_hitalama_guide_repository_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_status__status_shm_hitalama_guide_repository_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_repository['status'] >
		,
		ReturnType< $mol_status['status'] >
	>
	type $mol_status__attr_shm_hitalama_guide_repository_10 = $mol_type_enforce<
		({ 
			'data-sync-state': ReturnType< $shm_hitalama_guide_repository['sync_state'] >,
		})  & ReturnType< $mol_status['attr'] >
		,
		ReturnType< $mol_status['attr'] >
	>
	type $mol_button_minor__title_shm_hitalama_guide_repository_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_guide_repository_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_repository['refresh'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_major__title_shm_hitalama_guide_repository_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_shm_hitalama_guide_repository_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_repository['commit_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_shm_hitalama_guide_repository_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_guide_repository['commit'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_view__sub_shm_hitalama_guide_repository_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_guide_repository extends $mol_page {
		close( next?: any ): any
		Close_icon( ): $mol_icon_close
		Close( ): $mol_button_minor
		editable( ): boolean
		repository( next?: string ): string
		Repository_input( ): $mol_string
		Repository( ): $mol_labeler
		Notice( ): $mol_text
		status( ): string
		sync_state( ): string
		Status( ): $mol_status
		refresh( next?: any ): any
		Refresh( ): $mol_button_minor
		commit_enabled( ): boolean
		commit( next?: any ): any
		Commit( ): $mol_button_major
		Actions( ): $mol_view
		title( ): string
		catalog( ): $shm_hitalama_guide_catalog
		opened( next?: boolean ): boolean
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=repository.view.tree.d.ts.map